



































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import _, { map } from 'lodash';

import OrderDetailModal from '../modals/OrderDetailModal.vue';
import OrderFiltersModal from '../modals/OrderFiltersModal.vue';
import moment from 'moment-timezone';
import { asyncForEach, orderStoreBadge, validateStatusOrders } from '@/utils';
import { Spinner } from 'vue-image-spinner2';
import VueMonthlyPicker from 'vue-monthly-picker';

@Component({
    name: 'orders',
    data: function () {
        return {
            ordersPage_: 1,
        };
    },
    components: {
        OrderDetailModal,
        OrderFiltersModal,
        Spinner,
        VueMonthlyPicker,
    },
    filters: {
        date(val) {
            return val == null ? 'Rango de fecha' : moment(val).format('YYYY/MM/DD');
        },
    },
    computed: {
        ...mapState('auth', ['currentUser']),
        ...mapState('orders', ['allOrders', 'allOrdersLoading', 'ordersPerPage', 'ordersPage', 'ordersTotal', 'ordersSchedule', 'monthlySummary']),
        ...mapState('orders', {
            allOrders: (state: any) => {
                const allOrders = state.allOrders.map((order: any) => {
                    // order.splitted_order = JSON.parse(order.splitted_order);
                    // let splitted = JSON.parse(order.splitted_order);
                    // console.log(splitted.length);
                    if (order.order_date) {
                        order.order_date = moment(order.order_date).format('YYYY/MM/DD');
                    }

                    if (order.splitted_order) {
                        order.splitted_order = JSON.parse(order.splitted_order);
                        order.splitted_order = _.remove(order.splitted_order, function (o) {
                            return o != order.id;
                        });
                    }

                    // logistic_type
                    let logistic_type;
                    // console.log({ order });
                    switch (order.logistic_type) {
                        case 'fulfillment':
                            logistic_type = 'FULFILLMENT';
                            break;
                        case 'drop_off':
                            logistic_type = 'REGULAR';
                            break;
                        case 'acordar':
                            logistic_type = 'A-ACORDAR';
                            break;
                        case 'cross_docking':
                            logistic_type = 'M-E-COLECTA';
                            break;
                        case 'xd_drop_off':
                            logistic_type = 'ML-PLACES';
                            break;
                        default:
                            logistic_type = order.logistic_type;
                            break;
                    }

                    let status = order.status.replace(/ /g, '').split(',');
                    let status_order: any = [];

                    // status_order = status.map((substatus: any) => {
                    //     return validateStatusOrders(substatus, order.order_status);
                    // });

                    if (order.order_status == 'paid' || order.order_status == 'success') {
                        //check status for differents orders origin
                        let clearStatus: any = _.remove(status, function (n) {
                            return n != 'null' && n != 'paid' && n != 'undefined';
                        });
                        clearStatus = clearStatus[clearStatus.length - 1];

                        status_order = validateStatusOrders(clearStatus, order.order_status);

                    } else if (order.order_status == 'cancelled') {
                        let clearStatus: any = _.remove(status, function (n) {
                            return n != 'null' && n != 'undefined' && n != 'pack_splitted';
                            // && n != 'cancelled'
                        });
                        // console.log(clearStatus)
                        clearStatus = clearStatus[clearStatus.length - 1];
                        status_order = validateStatusOrders(clearStatus, order.order_status);
                    } else {
                        // check validation for ecommerce

                        if (order.logistic_type == 'ecommerce') {
                            status_order = validateStatusOrders('procesando_en_prodelec', order.order_status);
                        }

                        console.log('Check case');
                    }

                    if (order.intelisis_movement == null || order.intelisis_movement == 'null') {
                        order.intelisis_movement = 'Sin asignar';
                    }

                    // tags.status
                    // console.log('logistic_type => ', order.logistic_type, { order });

                    // console.log('status to validate: ', status_order.status);

                    let infoCollect = '';
                    let delay_info = '';

                    // console.log(order.estimated_handling_limit);
                    // console.log(order.active_status);
                    // if (order.active_status == 'Etiqueta_lista_para_imprimir' || order.active_status == 'Listo_para_recoleccion') {
                    if (status_order.status == 'Etiqueta lista para imprimir' || status_order.status == 'Listo para recolección') {
                        // console.log('check handling limit time... ', order.estimated_handling_limit);
                        let limitDate = moment(order.estimated_handling_limit).format('YYYY-MM-DD');
                        let today = moment().format('YYYY-MM-DD');
                        if (today > limitDate) {
                            delay_info = 'Estás con demora';
                        }
                    }

                    if (status_order.status == 'Etiqueta lista para imprimir' || status_order.status == 'Listo para recolección') {
                        let dateString = moment().format('YYYY/MM/DD');
                        let hour = +moment().format('HH');
                        let minute = +moment().format('mm');
                        // console.log({ hour });
                        // console.log({ minute });
                        let day = new Date(dateString).toLocaleString('en-us', { weekday: 'long' });
                        day = day.toLowerCase();
                        if (hour < 11) {
                            if (state.ordersSchedule[day].work) {
                                infoCollect =
                                    'Tienes que darle el paquete a la colecta que pasará hoy entre las 09:30 y 10:30 hrs para no demorarte.';
                            } else {
                                infoCollect = 'Tienes que darle el paquete a la colecta que pasará mañana.';
                            }
                        } else {
                            let tomorrow = moment().add(1, 'days').format('YYYY/MM/DD');
                            infoCollect = 'Tienes que darle el paquete a la colecta que pasará mañana.';
                        }
                    }
                    let post_products_info = [];
                    let meli_info = order.orderPublications;
                    let backend_info = order.products_order;
                    // ************* START GET INFO FROM PRODUCTS AND PUBLICATIONS
                    for (let i = 0; i < meli_info.length; i++) {
                        for (let x = 0; x < backend_info.length; x++) {
                            if (meli_info[i].id == backend_info[x].id_publication) {
                                post_products_info.push({
                                    id: meli_info[i].id,
                                    image: meli_info[i].image,
                                    title: meli_info[i].title,
                                    sales: meli_info[i].sales,
                                    price: meli_info[i].price,
                                    sku: backend_info[x].linked_products.map((item: any) => item.id),
                                });
                            }
                        }
                    }
                    // ************* END

                    return {
                        ...order,
                        permalink: `https://www.mercadolibre.com.mx/ventas/${order.id}/detalle`,
                        logistic_type,
                        // status,
                        tags: status_order,
                        delivery_info: infoCollect,
                        delay_info,
                        post_products_info,
                        // variant: status_variant
                    };
                });
                // console.log(allOrders);
                return _.orderBy(allOrders, 'order_date', 'desc');
            },
        }),
    },
})
export default class Orders extends Vue {
    orderStoreBadge = orderStoreBadge;
    private currentUser!: any;
    public allOrders!: any;
    public allOrdersLoading!: any;
    public ordersPerPage!: any;
    public ordersPage!: any;
    public ordersTotal!: any;
    public monthlySummary!: any;
    private activeOrderLoaded: boolean = false;
    private activeFilters: boolean = false;
    public ordersPage_!: any;
    // public logistic_type_filter: any = '';
    public order_word_search: any = '';
    public logistic_type_filter: any = 'all';
    public currentModal: any;
    logisticTypeOptions: any = [
        { value: 'all', text: 'Gestiones', disabled: true },
        { value: 'fulfillment', text: 'Fulfillment' },
        { value: 'drop_off', text: 'Regular' },
        { value: 'acordar', text: 'A acordar' },
        { value: 'cross_docking', text: 'M-E Colecta' },
        { value: 'ecommerce', text: 'E-commerce' },
    ];

    public orders_filter: any = 'all';
    ordersOptions: any = [
        { value: 'all', text: 'Órdenes', disabled: true },
        // { value: 'confirmed', text: 'Confirmada' },
        // { value: 'payment_required', text: 'Pago requerido' },
        // { value: 'payment_in_process', text: 'Pago en proceso' },
        // { value: 'partially_paid', text: 'Pagada parcialmente' },
        { value: 'paid', text: 'Pagada' },
        { value: 'cancelled', text: 'Cancelada' },
    ];

    public shipment_filter: any = 'all';
    shipmentOptions: any = [
        { value: 'all', text: 'Envíos', disabled: true },
        // { value: 'to_be_agreed', text: 'A convenir' },
        { value: 'pending', text: 'Pendiente' },
        // { value: 'ready_to_ship', text: 'Listo para enviar' },
        { value: 'shipped', text: 'Enviada' },
        { value: 'delivered', text: 'Entregada' },
        { value: 'out_for_delivery', text: 'En ruta para entrega' },
        { value: 'cancelled', text: 'Cancelada' },
        // { value: 'not_delivered', text: 'No entregada' },
        // { value: 'closed', text: 'Cerrada' },
        // { value: 'printed', text: 'Etiqueta impresa' },
        // { value: 'ready_to_print', text: 'Etiqueta lista para imprimir' },
        // { value: 'in_packing_list', text: 'En lista de empaque' },
        // { value: 'in_warehouse', text: 'Procesando en la bodega' },
        // { value: 'out_for_delivery', text: 'En camino' },
        // { value: 'delayed', text: 'Retrasada' },
        // { value: 'receiver_absent', text: 'Receptor ausente' },
        // { value: 'waiting_for_withdrawal', text: 'Esperando el retiro' },
        // { value: 'ready_to_pack', text: 'Listo para empacar' },
    ];

    public claimReturn_filter: any = 'all';
    claimReturnOptions: any = [
        { value: 'all', text: 'Órdenes', disabled: true },
        // { value: 'opened', text: 'Abierto' },
        { value: 'returns', text: 'Devolución' },
        { value: 'mediations', text: 'Reclamo' },
        { value: 'cancel', text: 'Cancelada' },
        { value: 'to_send', text: 'Para enviar' },
        { value: 'shipped', text: 'En camino' },
        // { value: 'cancel_purchase', text: 'Cancelación de compra (comprador)' },
        // { value: 'cancel_sale', text: 'Cancelación de compra (vendedor)' },
    ];

    public assignedMove_filter: any = 'all';
    assignedMoveOptions: any = [
        { value: 'all', text: 'Movimientos', disabled: true },
        { value: 'assigned', text: 'Asignados' },
        { value: 'unassigned', text: 'Sin asignar' },
    ];

    public date_filter: any = '';

    allOrdersHeaders = [
        { thClass: 'th', key: 'orderPublications', label: 'Detalle' },
        { thClass: 'th', key: 'id', label: 'No. Venta' },
        { thClass: 'th', sortable: true, key: 'order_date', label: 'Fecha' },
        { thClass: 'th', key: 'logistic_type', label: 'Gestión' },
        // { thClass: "th", key: "payment_amount", label: "Saldo" }, (node api)
        { thClass: 'th', key: 'tags', label: 'Estatus' },
        { thClass: 'th', key: 'ready_date', label: 'Tiempo en camino' },
        // { thClass: 'th', key: 'entry_amount', label: 'Ingreso' },
        // { thClass: 'th', key: 'payment_amount', label: 'Saldo' },
        { thClass: 'th', key: 'intelisis_movement', label: 'Movimiento' },
        { thClass: 'th', key: 'comments', label: 'Comentarios' },
        { thClass: 'th', key: 'package_manager', label: 'Responsable-Paquete' },
        { thClass: 'th', key: 'edit', label: '' },
    ];

    public dateRange: any = {
        startDate: null,
        endDate: null,
    };
    singleDatePicker: any = 'range';

    package_manager_options: any = [
        { value: null, text: 'Encargado', disabled: true },
        { value: 'Jonathan', text: 'Jonathan' },
        { value: 'Alejandro', text: 'Alejandro' },
        { value: 'Rigoberto', text: 'Rigoberto' },
        { value: 'Marco', text: 'Marco' }
    ];

    selectedMonth: any = '';
    months: any = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];

    canSee(roles: any) {
        let roleValidation = false;
        let user1Id = '8c39c042-be3d-4e7c-9f54-a840d655fe14'; // Montufar
        let user2Id = '69398834-1969-4dd8-bece-deff3c13404b'; // Dev user
        let user3Id = '91f3d64d-e790-4556-8af3-1835ca946715'; // Jocelyn
        switch (this.currentUser.role.name) {
            case 'Admin':
                roleValidation = _.intersection(roles, [this.currentUser.role.name]).length > 0;
                break;
            case 'Developer':
                roleValidation = _.intersection(roles, [this.currentUser.role.name]).length > 0;
                break;
            case 'MercadoLibre Manager':
                roleValidation = _.intersection(roles, [this.currentUser.role.name]).length > 0;
                if (this.currentUser.id != user1Id && this.currentUser.id != user2Id && this.currentUser.id != user3Id) {
                    roleValidation = false;
                }
                break;
            default:
                roleValidation = false;
                break;
        }
        return roleValidation;
    }

    setUrlPage(page: any) {
        // @ts-ignore
        this.$router.push({
            path: 'orders',
            query: {
                ...this.$route.query,
                page,
            },
        });
        this.ordersPage_ = page;
    }

    setUrlSort(ctx: any) {
        this.$router.push({
            path: 'orders',
            query: {
                ...this.$route.query,
                sortName: ctx.sortBy,
                sortValue: ctx.sortDesc ? 'desc' : 'asc',
            },
        });
    }

    setUrlSearch(search: string) {
        // @ts-ignore
        // this.clearFilters();
        search = search.trim();
        this.$router.push({
            path: 'orders',
            query: {
                ...this.$route.query,
                search,
            },
        });
    }

    // setUrlFilter(filter: string, status: string) {
    // 	this.clearFilters();
    // 	this.logistic_type_filter = filter;
    // 	// this.status_order_filter = status;
    // 	this.$router.push({
    // 		path: "orders",
    // 		query: {
    // 			...this.$route.query,
    // 			filterLogisticType: filter,
    // 			filterStatus: status
    // 		},
    // 	});
    // }

    clearFilters() {
        this.logistic_type_filter = 'all';
        this.orders_filter = 'all';
        this.shipment_filter = 'all';
        this.claimReturn_filter = 'all';
        // this.status_order_filter = 'all';
        this.order_word_search = '';
        this.date_filter = '';
        this.assignedMove_filter = 'all';
        this.$router.push({
            path: 'orders',
            query: {},
        });
        this.ordersPage_ = 1;
        this.dateRange = {
            startDate: null,
            endDate: null,
        };
    }

    changePackageManager(id: any, package_manager: any) {
        this.$store.dispatch('orders/putOneManager', {
            vm: this,
            id: id,
            package_manager: package_manager,
        });
    }

    printLabel(id: any, store: any) {
        this.$store.dispatch('orders/printLabel', {
            order_id: id,
            store,
        });
    }

    onEditOrder(id: number) {
        this.$store.dispatch('orders/getOne', { id });
        this.activeOrderLoaded = true;
        setTimeout(() => {
            this.$bvModal.show('order-detail-modal');
        }, 400);
    }

    onFilterLogisticType(logisticType: string) {
        this.$router.push({
            path: 'orders',
            query: {
                ...this.$route.query,
                filterLogisticType: logisticType,
            },
        });
    }

    onFilterOrders(order: string) {
        this.$router.push({
            path: 'orders',
            query: {
                ...this.$route.query,
                order_status_filter: order,
            },
        });
    }

    onFilterShipment(shipment: string) {
        this.$router.push({
            path: 'orders',
            query: {
                ...this.$route.query,
                shipment_status_filter: shipment,
            },
        });
    }

    onFilterClaimReturn(claimReturn: string) {
        // console.log({ claimReturn });
        this.$router.push({
            path: 'orders',
            query: {
                ...this.$route.query,
                claim_return_status_filter: claimReturn,
            },
        });
    }

    onFilterAssignedMove(assignedMove: string) {
        this.$router.push({
            path: 'orders',
            query: {
                ...this.$route.query,
                assigned_move_filter: assignedMove,
            },
        });
    }

    @Watch('date_filter')
    onFilterDay() {
        this.$router.push({
            path: 'orders',
            query: {
                ...this.$route.query,
                day_filter: this.date_filter.replace(/-/g, '/'),
            },
        });
    }

    onFilterDateRange() {
        let start_date = moment(this.dateRange.startDate).format('YYYY/MM/DD');
        let end_date: any = moment(this.dateRange.endDate).add(1, 'd');
        end_date = moment(end_date).format('YYYY/MM/DD') + '';
        // console.log(start_date, '--', end_date);
        this.$router.push({
            path: 'orders',
            query: {
                ...this.$route.query,
                start_date: start_date,
                end_date: end_date,
            },
        });
    }

    @Watch('selectedMonth')
    getSummary() {
        if (this.selectedMonth) {
            // console.log('working...', this.selectedMonth);
            let date = moment(this.selectedMonth).format('YYYY/MM');
            if (this.currentModal === "clientsSummary") {
                this.$store.dispatch('orders/monthlySummaryClients', { date: date, vm: this });
            } else if (this.currentModal === "ordersSummary") {
                this.$store.dispatch('orders/monthlySummaryOrders', { date: date, vm: this });
            }
            //     // this.$store.dispatch('orders/monthlySummaryOrders', { date: date, vm: this });

        }
    }

    @Watch('$route')
    getAllOrders() {
        // @ts-ignore
        const page = this.$route.query.page || 1;
        const search = this.$route.query.search || null;
        const sortName = this.$route.query.sortName || null;
        const sortValue = this.$route.query.sortValue || null;
        const filterLogisticType = this.$route.query.filterLogisticType || null;
        const filterStatus = this.$route.query.filterStatus || null;
        const order_status_filter = this.$route.query.order_status_filter || null;
        const shipment_status_filter = this.$route.query.shipment_status_filter || null;
        const claim_return_status_filter = this.$route.query.claim_return_status_filter || null;
        const day_filter = this.$route.query.day_filter || null;
        const assigned_move_filter = this.$route.query.assigned_move_filter || null;
        const start_date = this.$route.query.start_date || null;
        const end_date = this.$route.query.end_date || null;
        this.$store.dispatch('orders/getAll', {
            page,
            search,
            sortName,
            sortValue,
            filterLogisticType,
            filterStatus,
            order_status_filter,
            shipment_status_filter,
            claim_return_status_filter,
            day_filter,
            assigned_move_filter,
            start_date,
            end_date,
        });
        console.log(this.allOrders);

    }

    calculateReadyDate(ready_date, created_at) {
        if (!ready_date || !created_at) {
            return '---';
        }

        const readyDate = new Date(ready_date);
        const createdAt = new Date(created_at);
        const elapsedTime = readyDate.getTime() - createdAt.getTime();

        if (elapsedTime < 0) {
            return '---';
        }

        const totalSeconds = Math.floor(elapsedTime / 1000);
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        const formattedHours = hours.toString().padStart(2, '0');
        const formattedMinutes = minutes.toString().padStart(2, '0');
        const formattedSeconds = seconds.toString().padStart(2, '0');

        return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
    }

    mounted() {
        this.getAllOrders();
        this.ordersPage_ = 1;
    }

    openModal(modalId) {
        this.currentModal = modalId;
        this.$bvModal.show(modalId);
    }
}
